// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FeaturedCategoriesPayload, getFeaturedCategoriesData } from "@ces/App/Services/FeaturedCategories";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { CategoryModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandler<FeaturedCategoriesPayload, CategoryModel[]>;

export const SetLoading: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedCategories/setLoading",
        key: getDataViewKey(props.apiParameter),
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getFeaturedCategoriesData(props.apiParameter);
    } catch (error) {
        logger.error(error);
    }
};

export const DispatchCompleteLoadFeaturedCategoriesData: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedCategories/loadCategories",
        categories: props.apiResult,
        key: getDataViewKey(props.parameter),
    } as any);
};

export const ClearLoading: HandlerType = props => {
    props.dispatch({
        type: "xFeaturedCategories/CompleteLoad",
        key: getDataViewKey(props.parameter),
    } as any);
};

export const chain = [
    SetLoading,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadFeaturedCategoriesData,
    ClearLoading,
];

const loadFeaturedCategories = createHandlerChainRunner(chain, "loadFeaturedCategories");

export default loadFeaturedCategories;
